// ---------------------------------------------------------------------
// jQuery.collapse
//
// @version  0.0.1
// @author   Sanshiroh Sakai
// ---------------------------------------------------------------------
(function ($, window, document) {
  'use strict'; // メタ情報を定義

  const namespace = 'collapse';
  const version = '0.0.4'; // デフォルトオプションを定義

  const defaults = {
    containerSelector: '._js-collapse__container',
    buttonSelector: '._js-collapse__opener',
    buttonSuffixId: '_tab',
    buttonAppendTargetSelector: '._js-collapse__button-wrapper',
    panelSelector: '._js-collapse__panel',
    slideSpeed: 500,
    button: $('<button></button>', {
      type: 'button'
    })
  }; // コンストラクタを定義

  function Plugin(element, options) {
    this.element = element;
    this.settings = $.extend({}, defaults, options);
    this.$root = $(this.element);
    this.$containers = this.$root.find(this.settings.containerSelector);
    this.$panels = this.$root.find(this.settings.panelSelector);
    this._defaults = defaults;
    this._name = namespace;
    this._version = version;
    this.init();
  } // プロトタイプメソッドを定義


  $.extend(Plugin.prototype, {
    init: function () {
      this.initAttributes();
      this.initEvents();
    },
    // 初期化処理：初期属性値をセット
    initAttributes: function () {
      this.$root.attr('role', 'tablist');
      this.$containers.each($.proxy(function (index, elem) {
        const $container = $(elem);
        const $button = this.settings.button.clone();
        const $panel = $container.find(this.settings.panelSelector); // 生成されたボタンを HTML として出力

        $container.find(this.settings.buttonAppendTargetSelector).append($button);
        const panelId = $panel.attr('id') || this.$root.attr('id') + '-' + index;
        const buttonId = panelId + this.settings.buttonSuffixId;
        $button.attr({
          'class': this.settings.buttonSelector.substr(1),
          'aria-expanded': 'false',
          'aria-selected': 'false',
          'role': 'tab',
          'id': buttonId,
          'aria-controls': panelId
        });
        $panel.attr({
          'aria-hidden': 'true',
          'role': 'tabpanel',
          'id': panelId,
          'aria-labelledby': buttonId
        }).hide(); // aria 属性がセットされると同時に初期非表示に設定
      }, this)); // 出力されたボタン全体をコンストラクタプロパティに設定

      this.$buttons = this.$root.find(this.settings.buttonSelector);
    },
    // 初期化処理：イベントにハンドラを設定
    initEvents: function () {
      this.$root.on('focus.collapse', this.settings.buttonSelector, $.proxy(this.focusButtonEventHandler, this));
      this.$root.on('click.collapse', this.settings.buttonSelector, $.proxy(this.clickButtonEventHandler, this));
    },
    // イベントハンドラ：フォーカス
    focusButtonEventHandler: function (e) {
      const $button = $(e.target); // ボタン全体を初期化

      this.$buttons.attr('aria-selected', 'false'); // フォーカス対象の属性を変更

      $button.attr('aria-selected', 'true');
    },
    // イベントハンドラ：クリック
    clickButtonEventHandler: function (e) {
      // クリックされたボタンと、ボタンに連動するパネル要素を取得
      const $button = $(e.target);
      const $panel = $('#' + $button.attr('aria-controls'));
      const $container = $button.closest(this.settings.containerSelector); // ボタン全体を初期化し、クリック対象の属性を変更

      this.$buttons.attr('aria-selected', 'false');
      $button.attr('aria-selected', 'true'); // ステートに応じてボタンとパネルの属性値を変更

      if ($button.attr('aria-expanded') === 'false') {
        // 閉じている
        $button.attr('aria-expanded', 'true');
        $panel.attr('aria-hidden', 'false');
        $panel.slideDown(this.settings.slideSpeed); // $container.addClass('-open');
      } else {
        // 開いている
        $button.attr('aria-expanded', 'false');
        $panel.attr('aria-hidden', 'true');
        $panel.slideUp(this.settings.slideSpeed); // $container.removeClass('-open');
      }

      e.stopPropagation(); // 親要素へのバブリングを停止

      e.preventDefault(); // 要素の標準イベントを停止
    }
  }); // jQuery.prototype にプラグイン名を追加し、
  // 受け取った jQuery オブジェクトにプラグインコンストラクタのインスタンスを設定

  $.fn[namespace] = function (options) {
    return this.each(function () {
      if (!$.data(this, `plugin_${namespace}`)) {
        $.data(this, `plugin_${namespace}`, new Plugin(this, options));
      }
    });
  }; // プラグインの実行


  $('._js-collapse').collapse({
    slideSpeed: 300
  });
})(jQuery, window, document);